export default {
  init() {
    // JavaScript to be fired on the about us page
    console.log('arranca el teatro');

    $('#quitar-mute').click( function (){
      if( $('video').prop('muted', true) )
      {
        $('video').prop('muted', false);
        $('#quitar-mute').css('display','none');
        $('#mute-video').css('display','block');
      }
    });

    $('#mute-video').click( function (){
      $('video').prop('muted', true);
      $('#quitar-mute').css('display','block');
      $('#mute-video').css('display','none');
    });



  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-teatro.js